import endpoints from '../endpoints';
import StoreFromFile from './StoreFromFile';

class SeasonsStore extends StoreFromFile {
  constructor(name) {
    super(name);
    this.storeSavedName = 'XXSSeasonsStores';
    this.endpoint = endpoints.seasons.get;
  }
}

export default SeasonsStore;
